import { render, staticRenderFns } from "./Show-contato-empresa.vue?vue&type=template&id=075d2f3e&scoped=true&"
import script from "./Show-contato-empresa.vue?vue&type=script&lang=js&"
export * from "./Show-contato-empresa.vue?vue&type=script&lang=js&"
import style0 from "./Show-contato-empresa.vue?vue&type=style&index=0&id=075d2f3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075d2f3e",
  null
  
)

export default component.exports